const errorMessages = {
  email: { required: "An email is required" },
  firstName: { required: "First Name is required" },
};

export const requestDemoRules = {
  email: {
    required: errorMessages.email.required,
  },
  firstName: {
    required: errorMessages.firstName.required,
  },
};
